import { ReactComponent as LoaderIcon } from '../../dashboard/assets/icons/LoaderIcon.svg';
import styles from './PageLoader.module.scss';

export const PageLoader: React.FC = () => (
  <div className={styles.pageLoader}>
    <LoaderIcon className={styles.loader} height={72} width={72} />
  </div>
);
